import { CrudTable, StatusBadge, Rating } from "@/components/shared";

const STAGES = [
  "1. Telecaller Enquiry", "2. Clinic Walk-in", "3. Doctor Consultation",
  "4. Post-Visit", "5. Pre-Operation", "6. Post-Operation", "7. Post-Op Follow-up",
];

const YesNo = ({ v }) => <span className={v ? "text-[#34d399]" : "text-slate-500"}>{v ? "Yes" : "No"}</span>;

export default function FollowUps() {
  const columns = [
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "surgery_date", label: "Surgery", render: (r) => r.surgery_date ? r.surgery_date.slice(0, 10) : "—" },
    { key: "followup_type", label: "Type", render: (r) => <StatusBadge value={r.followup_type} /> },
    { key: "scheduled_date", label: "Scheduled", render: (r) => r.scheduled_date ? r.scheduled_date.slice(0, 10) : "—" },
    { key: "actual_call_date", label: "Actual Call", render: (r) => r.actual_call_date ? r.actual_call_date.slice(0, 10) : "—" },
    { key: "call_outcome", label: "Outcome" },
    { key: "completed", label: "Done", render: (r) => <YesNo v={r.completed} /> },
    { key: "next_followup_date", label: "Next", render: (r) => r.next_followup_date ? r.next_followup_date.slice(0, 10) : "—" },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked to Journey record)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "surgery_date", label: "Surgery Date", type: "date" },
    { key: "followup_type", label: "Follow-Up Type", type: "select", options: ["24-hr Check-in", "7-day", "30-day", "90-day"] },
    { key: "scheduled_date", label: "Scheduled Date", type: "date" },
    { key: "actual_call_date", label: "Actual Call Date", type: "date" },
    { key: "call_outcome", label: "Call Outcome", type: "select", options: ["Recovering Well", "Has Concerns", "Needs Doctor Review", "Unreachable"] },
    { key: "next_followup_date", label: "Next Follow-Up Date", type: "date" },
    { key: "completed", label: "Completed", type: "switch" },
    { key: "notes", label: "Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="followups" endpoint="followups" dateField="scheduled_date"
      title="Post-Surgery Follow-Ups"
      subtitle="Did we actually call them back? The core discipline tool — overdue calls push to the notification bell."
      columns={columns} fields={fields}
      defaults={{ followup_type: "24-hr Check-in", completed: false }}
    />
  );
}
